import { Flex, Icon } from '@chakra-ui/react';
import { FiCheck } from '@react-icons/all-files/fi/FiCheck';

import { STAGE_ICONS, StageView, nodeStyleByState } from './utils';

type StageNodeProps = {
  stage: StageView;
  size: string;
};

const StageNode = ({ stage, size }: StageNodeProps) => {
  const node = nodeStyleByState[stage.state];
  return (
    <Flex
      position="relative"
      zIndex={1}
      flex="none"
      w={size}
      h={size}
      borderRadius="999px"
      align="center"
      justify="center"
      borderWidth="1.5px"
      borderStyle="solid"
      transition="background 160ms ease, color 160ms ease, border-color 160ms ease"
      bg={node.bg}
      color={node.color}
      borderColor={node.borderColor}
      boxShadow={node.boxShadow}
    >
      <Icon as={stage.state === 'done' ? FiCheck : STAGE_ICONS[stage.key]} boxSize="14px" />
    </Flex>
  );
};

export default StageNode;
